import type { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import type CrmFundraisingOpportunity from '@/types/serializers/CrmFundraisingOpportunity'
import {
  OPPORTUNITY_STATUS_LABELS,
  STATUS_BADGE_VARIANT,
} from '@/lib/fundraising-labels'

export const opportunityColumns: ColumnDef<CrmFundraisingOpportunity, unknown>[] = [
  {
    accessorKey: 'name',
    header: 'Nom',
    meta: { sortKey: 'name' },
    // Whole-row click opens the detail sheet; full page still reachable by URL.
    cell: ({ row }) => <span className="font-medium">{row.original.name}</span>,
  },
  {
    accessorKey: 'status',
    header: 'Statut',
    meta: { sortKey: 'status' },
    cell: ({ row }) => {
      const { status } = row.original
      const label = typeof status === 'object' ? status.label : String(status)
      return (
        <Badge variant="outline">
          {label}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'estimated_amount_formatted',
    header: 'Montant estime',
    meta: { sortKey: 'estimated_amount_millimes' },
    cell: ({ row }) => (
      <span className="tabular-nums">{row.original.estimated_amount_formatted}</span>
    ),
  },
  {
    accessorKey: 'donor_name',
    header: 'Donateur',
    cell: ({ row }) => row.original.donor_name ?? '—',
  },
  {
    accessorKey: 'expected_close_date',
    header: 'Date prevue',
    cell: ({ row }) =>
      row.original.expected_close_date
        ? new Date(row.original.expected_close_date).toLocaleDateString('fr-FR')
        : '—',
  },
  {
    accessorKey: 'assignee_name',
    header: 'Responsable',
    cell: ({ row }) => row.original.assignee_name ?? '—',
  },
]
